import moment from 'moment-timezone';

export const formatDate = (date, duration, tz = 'GMT') => {
  switch (duration) {
    case 'today':
      return moment(date).tz(tz).format('HH:mm')
    case 'week':
      return moment(date).tz(tz).format('dddd')
    case 'month':
      return moment(date).tz(tz).format('MM-DD')
    case 'year':
      return moment(date).tz(tz).format('MMMM')
    default:
      return moment(date).tz(tz).format()
  }
}

export const formatDateFromRange = (date, {startDate, endDate, tz = 'GMT'}) => {
  const timezone = tz || 'GMT'
  const daysDiff = moment(startDate).tz(timezone).diff(moment(endDate).tz(timezone), 'days');
  if (Math.abs(daysDiff) > 1) return moment(date).tz(timezone).format('MM-DD');
  else return moment(date).tz(timezone).format('DD - HH:mm');
}



// WEBPACK FOOTER //
// ./src/helpers/duration-helpers.js